




import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "CoordinatePrompt",
})
export default class CoordinatePrompt extends Vue {
     get tipCoord() {
        return this.$store.state.tipCoord
    } 
}
